<template>
    <div>
        <v-select
            :label="label"
            :items="choices"
            v-model="internal_value"
            return-object
            v-on:input="onChange"
            :rules="select_rules"
        />
    </div>
</template>

<script>
export default {

    props: {

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        value: {
            type: String,
            default: function() { return null; },
        },

        label: {
            type: String,
            default: function() { return 'Team Number'; },
        },

        required: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            internal_value: null,
            choices: [],
            rules: {
                required: (value) => {

                    if ( value == null || value.value == null ) return 'Required';

                    return true;
                },
            },
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {

            if ( this.organization_id == null )
            {
                this.choices = [];
                this.internal_value = null;
                return;
            }

            let search = {
                'organization_id' : this.organization_id,
            };

            this.$rc.showSpinner();
            this.$rc.searchTeamNumbers(
                search,
                (data) => {
                    this.$rc.hideSpinner();

                    this.choices = this.createChoices(data.results);
                    this.internal_value = this.createInternalValue(this.value);
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to list locations');
                },
            );
        },

        createChoices(team_numbers)
        {
            let ret = [];

            ret.push({
                'text' : 'Select Team Number',
                'value' : null,
            });

            for ( let i = 0; i < team_numbers.length; i++ )
            {
                ret.push({
                    'text' : team_numbers[i].assigned_to_employee_group_label,
                    'value' : team_numbers[i].endpoint,
                });
            }

            return ret;
        },

        createInternalValue(value)
        {
            let choices = this.choices;

            for ( let i = 0; i < choices.length; i++ )
            {
                if ( choices[i].value == value )
                    return choices[i];
            }

            return choices[0];
        },

        onChange(value)
        {
            this.$emit('input',value.value);
        },
    },

    computed: {
        select_rules() {

            if ( this.required == true )
                return [this.rules.required];

            return [];
        }
    },

    watch: {
        organization_id(newValue, oldValue) {
            this.update();
        },

        value(newValue, oldValue) {
            this.internal_value = this.createInternalValue(newValue);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>